import { defineQuery } from 'next-sanity'
import { inlineCtaFields } from '../atoms'

export const quoteBlockFields = `
  _id,
  _type,
  quote,
  backgroundColor,
  "CTA": cta {
    ${inlineCtaFields}
  }
`

export const QUOTE_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "quote-block"][0]{
    ${quoteBlockFields}
  }
`)
